<template>
    <section id="help">
        <article v-html="data"></article>
    </section>
</template>

<script>
    import { getPointUseRule, getSignRule } from '../../common/api/helper';
    export default {
        data () {
            return {
                data: ''
            }
        },
        created (){
            switch (this.type) {
                case 'integral':           // 积分规则
                    this.getPointUseRule()
                    break;
                case 'checkin':           // 签到规则
                    this.getSignRule()
                    break;
            }
        },
        computed: {
            type () {
                return this.$route.params.type
            }
        },
        watch: {
        },
        methods: {
            getPointUseRule () {
                getPointUseRule().then(rep => {
                    if (rep.data.code === 0) {
                        this.data = rep.data.data.pointRule
                    }
                })
            },
            getSignRule () {
                getSignRule().then(rep => {
                    if (rep.data.code === 0) {
                        this.data = rep.data.data.signRule
                    }
                })
            }
        }
    }
</script>

<style  lang="scss">
    @import '../../assets/css/px2rem.scss';
    #help{
        article{
            padding:px2rem(20);
            font-size: px2rem(16);
            line-height: px2rem(24);
            text-align: justify;
        }
    }
</style>